module.exports = __webpack_public_path__ + "img/mobile-android.b71e74bc.png";